var React = require('react');

function BillingIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 16a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1z","fill":"#fff","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H4zm16 2H4a1 1 0 0 0-1 1v1h18V7a1 1 0 0 0-1-1zm1 4H3v7a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-7z","fill":"#fff","key":1})]);
}

BillingIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BillingIcon;

BillingIcon.default = BillingIcon;
